// extracted by mini-css-extract-plugin
export default {"main":"InstaConnectForm_main__BT4Z6","spinner":"InstaConnectForm_spinner__Vcn9g","content":"InstaConnectForm_content__KgpMo","error":"InstaConnectForm_error__9J37g"};